import React, { useState } from 'react';
import SPAButton from '../../shared/SPAButton';
import SPAPill from '../../shared/SPAPill';
import SPAPageHeader from '../../shared/SPAPageHeader';
import SPARowList from '../../shared/SPARowList';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { readRecentLookups } from './recentLookups';
import rolePillTone from './rolePillTone';
import type { RecentLookup } from './recentLookups';
import type { UserType } from './types';

const TIPS = [
  {
    detail: 'also finds orders by their contact — matching transactions list under the user results.',
    label: 'Email',
  },
  {
    detail: 'is on by default; uncheck it to match the start of a name, email, or username.',
    label: 'Exact match',
  },
  {
    detail: 'jumps straight to one account — handy from a Sentry event or support ticket.',
    label: 'User ID',
  },
];

const RecentLookupButton = ({ lookup, onSelect }: {
  lookup: RecentLookup;
  onSelect: (userType: UserType, id: number) => void;
}) => (
  <SPAButton className="tw-gap-2 tw-rounded-full" onClick={() => onSelect(lookup.user_type, lookup.id)}>
    {lookup.name}
    <SPAPill className="tw-capitalize" tone={rolePillTone(lookup.role)}>{lookup.role}</SPAPill>
  </SPAButton>
);

const SearchLanding = ({ onSelect }: { onSelect: (userType: UserType, id: number) => void }) => {
  const [recents] = useState(() => readRecentLookups());

  return (
    <div>
      <SPAPageHeader title="Look up a user" />
      <p className="tw-mb-5 tw-mt-0 tw-text-sm tw-text-spa-secondary">
        Search across every subscriber by email, username, name, or user ID.
      </p>

      <div className="tw-flex tw-max-w-3xl tw-flex-col tw-gap-6">
        <section>
          <SPASectionHeading title="Tips" />
          <SPARowList>
            {TIPS.map(tip => (
              <div key={tip.label} className="tw-flex tw-gap-4">
                <span className="tw-w-32 tw-shrink-0 tw-font-semibold tw-text-spa-accent-text">{tip.label}</span>
                <span className="tw-min-w-0 tw-text-spa-secondary">{tip.detail}</span>
              </div>
            ))}
          </SPARowList>
        </section>

        {recents.length > 0 && (
          <section>
            <SPASectionHeading title="Recent lookups" />
            <div className="tw-flex tw-flex-wrap tw-gap-2">
              {recents.map(lookup => (
                <RecentLookupButton
                  key={`${lookup.user_type}-${lookup.id}`}
                  lookup={lookup}
                  onSelect={onSelect}
                />
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default SearchLanding;
